import { CircularProgress, FormHelperText, Grid, MenuItem, TextField } from '@material-ui/core'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import LocalizationService from '../../../services/LocalizationService'
import { GlobalTextField } from '../../Core/Input/ControlledTextField'

export const MotorcycleLienholderSection = ({ isLoadingStates, states, setStateFromAutocomplete }) => {
  const methods = useFormContext()
  return (
    <div>
      <div className="text-body blue bold margin-top-basic margin-bottom-basic">Lienholder details</div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <GlobalTextField
            fullWidth
            label="Name"
            name="lienholder_name"
            inputRef={methods.register({ required: true })}
            errors={methods.errors}
            helperText={!!methods.errors.lienholder_name && 'Required'}
            defaultValue={methods.control.defaultValuesRef.current.lienholder_name || ''}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <GlobalTextField
            fullWidth
            label="Address line"
            name="lienholder_address"
            inputRef={methods.register({ required: true })}
            errors={methods.errors}
            helperText={!!methods.errors.lienholder_address && 'Required'}
            defaultValue={methods.control.defaultValuesRef.current.lienholder_address || ''}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <GlobalTextField
            fullWidth
            label="City"
            name="lienholder_city"
            inputRef={methods.register({ required: true })}
            errors={methods.errors}
            helperText={!!methods.errors.lienholder_city && 'Required'}
            defaultValue={methods.control.defaultValuesRef.current.lienholder_city || ''}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <div className="full-width margin-right-basic">
            <Controller
              rules={{ required: true, validate: x => x && x != 'statedefault' }}
              name="lienholder_state"
              as={
                !isLoadingStates ? (
                  <TextField
                    InputLabelProps={{ className: 'avenir-book' }}
                    error={!!methods.errors.lienholder_state}
                    fullWidth
                    label={LocalizationService.STRINGS.state}
                    defaultValue={methods.control.defaultValuesRef.current.lienholder_state || ''}
                    select
                    variant="outlined"
                  >
                    <MenuItem disabled value={'statedefault'}>
                      <div className="placeholder-text">{LocalizationService.STRINGS.state}</div>
                    </MenuItem>
                    {[...states]
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .map(item => (
                        <MenuItem key={item.code} value={item.code}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </TextField>
                ) : (
                  <CircularProgress />
                )
              }
              control={methods.control}
            />
            {!!methods.errors.lienholder_state && (
              <FormHelperText error={!!methods.errors.lienholder_state}>
                {methods.errors.lienholder_state.type == 'validate' ? 'Not available' : 'Required'}
              </FormHelperText>
            )}
          </div>
          <TextField
            InputLabelProps={{ className: 'avenir-book' }}
            name="lienholder_state"
            onChange={e => {
              setStateFromAutocomplete(e.target.value)
            }}
            style={{ height: 0, width: 0 }}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <GlobalTextField
            fullWidth
            label="Zip code"
            name="lienholder_zipcode"
            defaultValue={methods.control.defaultValuesRef.current.lienholder_zipcode || ''}
            inputRef={methods.register({ required: true })}
            errors={methods.errors}
            helperText={!!methods.errors.lienholder_zipcode && 'Required'}
          />
        </Grid>
      </Grid>
    </div>
  )
}
